import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { NoResultsFoundIcon } from '@/assets/icons/NoResultsFoundIcon';

import { AddMissingProfileMenu } from '../AddMissingProfileMenu/AddMissingProfileMenu';

import { noDcrsOverlayStyles as sx } from './NoDCRsOverlay.styles';

export const NoDCRsOverlay = () => {
	const { t } = useTranslation();

	return (
		<Box sx={sx.root}>
			<Typography variant='subtitle1' sx={sx.title}>
				{t('No DCRs yet')}
			</Typography>
			<NoResultsFoundIcon sx={sx.icon} />
			<AddMissingProfileMenu />
		</Box>
	);
};
